var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"aha-emit-action",rawName:"v-aha-emit-action"}],staticClass:"flex",on:{"click":function($event){return _vm.onUndoButtonClicked()}}},[_c('aha-button',{attrs:{"variant":"base","buttonIcon":_vm.buttonIcon,"submitting":_vm.isRestoringOriginalSlide}},[_vm._v("\n    "+_vm._s(_vm.$i18nPresenter.t('Undo'))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }